import React, { useContext, useState, useEffect } from 'react'
import { LanguageContext } from '../Language/LanguageContext'
import { NotifyContext } from '../Library/Notify'
import { Row, Col, Form, Button } from 'react-bootstrap'
import { createRole } from '../Network/Role'
import { useHistory } from 'react-router-dom'
import { Loading, HeaderTitle } from '../Library'
import { setDocumentTitle } from '../AppTitle'

function CreateRole() {
    const [isLoading, setLoading] = useState(false)
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.role
    const [roleName, setRoleName] = useState("")
    const [roleLevel, setRoleLevel] = useState("")
    const history = useHistory()
    const notify = useContext(NotifyContext)

    const userRoleLevel = localStorage.getItem("role_level")

    const level = [
        {value: 1, label: lang.super_admin, isShow: userRoleLevel <= 1},
        {value: 2, label: lang.high_level, isShow: userRoleLevel <= 2},
        {value: 3, label: lang.med_level, isShow: userRoleLevel <= 3},
        {value: 4, label: lang.low_level, isShow: userRoleLevel <= 4}
    ]

    const submit = () =>{
        setLoading(true)
        createRole(roleName, roleLevel,
            ()=>{
                setLoading(false)
                notify.showNotify(lang.add_role_success, lang.add_role_success_desc, 0)
                history.push("/role")
            },
            (error)=>{
                setLoading(false)
                notify.showNotify("Something wrong", error.message, 2)
            })
    }

    useEffect(()=>{
        setDocumentTitle("Create Role")
    },[])

    return (
        <div>
            { isLoading ? <Loading/>: null }
            <HeaderTitle title={lang.add_role} isShowBack backTo="/role"/>
            <Row>
                <Col md={10} lg={8} xl={6}>
                    <Form
                    onSubmit={(e)=>{
                        e.preventDefault()
                        submit()
                    }}>
                        <Form.Group>
                            <Form.Label>{lang.role_name}</Form.Label>
                            <Form.Control
                            value={roleName}
                            onChange={(e)=>setRoleName(e.target.value)}
                            required/>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.permission_level}</Form.Label>
                            <Form.Control 
                            as="select" 
                            onChange={(e)=>setRoleLevel(e.target.value)}
                            required>
                                <option value="">{lang.choose_level}</option>
                                { level.map((item, key)=>
                                <option value={item.value} key={key} hidden={!item.isShow}>{item.label}</option>
                                )}
                            </Form.Control>
                        </Form.Group>
                        <hr/>
                        <Button
                        type="submit"
                        >
                            {lang.add_role}
                        </Button>
                    </Form>
                </Col>
            </Row>
        </div>
    )
}

export default CreateRole
